import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FolderKanban, MessageSquareQuote, Mail, Settings, LogOut, Menu, X, MapPin, SlidersHorizontal, Image, Building, Wrench } from "lucide-react";

const sidebarItems = [
  { label: "Dashboard", to: "/admin", icon: LayoutDashboard, end: true },
  { label: "Slider", to: "/admin/slider", icon: SlidersHorizontal },
  { label: "Galeri", to: "/admin/gallery", icon: Image },
  { label: "Hakkımızda", to: "/admin/about", icon: Building },
  { label: "Hizmetler", to: "/admin/services", icon: Wrench },
  { label: "Projeler", to: "/admin/projects", icon: FolderKanban },
  { label: "Görüşler", to: "/admin/testimonials", icon: MessageSquareQuote },
  { label: "Mesajlar", to: "/admin/messages", icon: Mail },
  { label: "Harita Pinleri", to: "/admin/map-pins", icon: MapPin },
  { label: "Ayarlar", to: "/admin/settings", icon: Settings },
];

export default function AdminLayout({ user, onLogout }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("bct_token");
    localStorage.removeItem("bct_user");
    onLogout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#0f1117] flex" data-testid="admin-layout">
      {sidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />}

      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-[#161923] border-r border-white/5 flex flex-col transition-transform duration-300 lg:translate-x-0 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`} data-testid="admin-sidebar">
        <div className="h-16 flex items-center justify-between px-5 border-b border-white/5">
          <a href="/" className="flex items-baseline gap-0.5">
            <span className="text-xl font-extrabold tracking-tighter text-[#FF5A00]" style={{ fontFamily: "Outfit" }}>BCT</span>
            <span className="text-xl font-extrabold tracking-tighter text-white" style={{ fontFamily: "Outfit" }}> YAPI</span>
          </a>
          <button className="lg:hidden text-slate-400" onClick={() => setSidebarOpen(false)}><X size={20} /></button>
        </div>

        <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto">
          {sidebarItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-[#FF5A00]/10 text-[#FF5A00]" : "text-slate-400 hover:text-white hover:bg-white/5"}`}
              style={{ fontFamily: "Outfit" }}
              data-testid={`sidebar-${item.to.split("/").pop() || "dashboard"}`}
            >
              <item.icon size={18} /> {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/5">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 rounded-full bg-[#FF5A00]/20 flex items-center justify-center text-[#FF5A00] text-xs font-bold">{user?.name?.[0] || "A"}</div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-white font-medium truncate">{user?.name || "Admin"}</p>
              <p className="text-xs text-slate-500 truncate">{user?.email}</p>
            </div>
          </div>
          <button onClick={handleLogout} className="flex items-center gap-2 w-full px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-red-400 hover:bg-red-500/10 transition-colors" data-testid="admin-logout">
            <LogOut size={16} /> Çıkış Yap
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-h-screen">
        <header className="h-16 bg-[#161923] border-b border-white/5 flex items-center px-5 lg:px-8 gap-4">
          <button className="lg:hidden text-slate-400" onClick={() => setSidebarOpen(true)} data-testid="sidebar-toggle"><Menu size={22} /></button>
          <div className="flex-1" />
          <span className="text-xs text-slate-500" style={{ fontFamily: "Outfit" }}>Yönetim Paneli</span>
        </header>
        <main className="flex-1 p-5 lg:p-8 overflow-y-auto"><Outlet /></main>
        <footer className="px-5 lg:px-8 py-3 border-t border-white/5 flex justify-end">
          <p className="text-xs text-slate-600" style={{ fontFamily: "Outfit" }} data-testid="admin-developer-credit">Developer By Ferhat Gündoğdu 2026</p>
        </footer>
      </div>
    </div>
  );
}
